import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

// Pages
import HomePage from './pages/HomePage';
import PrivacyPage from './pages/PrivacyPage';
import LegalPage from './pages/LegalPage';
import SuccessPage from './pages/SuccessPage';
import AdminPage from './pages/admin/AdminPage';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminSubmissionDetail from './pages/admin/AdminSubmissionDetail';
import AdminLogin from './pages/admin/AdminLogin';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <header className="header">
          <div className="container">
            <div className="header-content">
              <a href="/" className="logo">China Readiness Check</a>
              <nav className="nav-links">
                <a href="/privacy" className="nav-link">Privacy Notice</a>
                <a href="/legal" className="nav-link">Legal Information</a>
              </nav>
            </div>
          </div>
        </header>

        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/legal" element={<LegalPage />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/admin" element={<AdminPage />} >
              <Route index element={<AdminLogin />} />
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="submissions/:id" element={<AdminSubmissionDetail />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>

        <footer className="footer">
          <div className="container">
            <div className="footer-content">
              <p className="copyright">© 2026 昆山蕴启工业智能制造实验室有限公司<br/>Smart Factory (Kunshan) Co., Ltd.</p>

              <div className="legal-links">
                <a href="/privacy" className="footer-link">Privacy Notice</a>
                <a href="/legal" className="footer-link">Legal Information</a>
                <a
                  href="https://beian.miit.gov.cn/"
                  className="icp-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  苏ICP备18021122号-1
                </a>
                <a
                  href="https://beian.mps.gov.cn/#/query/webSearch?code=32058302002589"
                  className="public-security-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/gongan-beian.png"
                    alt="公安备案"
                    width="20"
                    height="20"
                    style={{ verticalAlign: 'middle', marginRight: '4px' }}
                  />
                  苏公网安备32058302002589号
                </a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </BrowserRouter>
  );
}

export default App;
